import ApiGenerator from '@services/ApiGenerator';

const GET = 'osba/account/DEMOGRAPHIC_INFO_GET';
const GET_ERROR = 'osba/account/DEMOGRAPHIC_INFO_GET_ERROR';
const GET_RECEIVED = 'osba/account/DEMOGRAPHIC_INFO_GET_RECEIVED';
const SAVE = 'osba/account/DEMOGRAPHIC_INFO_SAVE';
const SAVE_ERROR = 'osba/account/DEMOGRAPHIC_INFO_SAVE_ERROR';
const SAVE_RECEIVED = 'osba/account/DEMOGRAPHIC_INFO_SAVE_RECEIVED';

const initialState = {
  Gender: 0,
  IsHispanic: false,
  CurrentLanguage: '',
  RaceKey: '',
  RaceValue: '',
  OtherSexualOrientation: '',
  SexualOrientationId: null,
  loading: false,
  error: '',
};

const mapResponse = (data) => {
  data.Languages.sort();

  return {
    ...data,
    Gender: `${data.Gender}`,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SAVE:
      return {
        ...state,
        ...action.data,
        loading: true,
        error: '',
      };
    case GET_RECEIVED:
    case SAVE_RECEIVED:
      return {
        ...state,
        ...mapResponse(action.data),
        loading: false,
      };
    case GET_ERROR:
    case SAVE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const getDemographicInfo = () => ({
  type: GET,
});

export const saveDemographicInfo = data => ({
  type: SAVE,
  data: {
    Gender: data.Gender,
    IsHispanic: data.IsHispanic,
    Languages: data.Languages,
    RaceKey: data.RaceValue,
    RaceValue: data.RaceValue,
    OtherSexualOrientation: data.OtherSexualOrientation,
    SexualOrientationId: parseInt(data.SexualOrientationId, 10),
  },
});

export const middleware = () => next => (action) => {
  const api = ApiGenerator(next);

  next(action);

  switch (action.type) {
    case GET:
      api('get', '/DemographicInformation/GetDemographicInformation', GET);
      break;
    case SAVE:
      api('post', '/DemographicInformation/SaveDemographicInformation', SAVE, {
        ...action.data,
      });
      break;
    default:
      break;
  }
};

export default reducer;
